import {
  CONTRACT_START_LEGEND_LABEL,
  CONTRACT_START_STYLES,
  STATUS_LABEL,
  STATUS_STYLES,
} from '../constants';
import type { AvailabilityStatus } from '../types';

const STATUSES: AvailabilityStatus[] = ['AVAILABLE', 'HELD', 'BOOKED', 'UNAVAILABLE'];

export const AvailabilityLegend = () => (
  <div aria-label="Availability status legend" className="flex flex-wrap gap-2" role="list">
    {STATUSES.map((status) => (
      <span
        className={`rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_STYLES[status]}`}
        key={status}
        role="listitem"
      >
        {STATUS_LABEL[status]}
      </span>
    ))}
    <span
      className={`rounded-full px-2.5 py-1 text-xs font-medium ${CONTRACT_START_STYLES}`}
      data-cy="provider-calendar-legend-contract-start"
      role="listitem"
    >
      {CONTRACT_START_LEGEND_LABEL}
    </span>
  </div>
);
